import { z } from 'zod';

export const LOCALES = ['en', 'de', 'zh', 'ru'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'en';
export const zLocale = z.enum(LOCALES);

export const THEMES = ['dark', 'light', 'system'] as const;
export type Theme = (typeof THEMES)[number];

export const GAME_IDS = [
  'crash',
  'pot',
  'roulette',
  'garden',
  'deep',
  'spaceport',
  'sweet-shop',
  'workshop',
  'koi-pond',
  'lucky-lever',
  'neon-arcade',
  'pirate-cove',
  'carp',
  'firecrackers',
  'hongbao',
  'mahjong',
  'mahjong-table',
  'zhajinhua',
  'doudizhu',
  // skill games (wave A of docs/four-games-mobile-plan.md): «Puzzles» and «Strategy», see catalog.ts
  'tile-match',
  'color-sort',
  'daily-words',
  'chess',
] as const;
export type GameId = (typeof GAME_IDS)[number];
export const SLOT_IDS = ['garden', 'deep', 'spaceport', 'sweet-shop', 'workshop', 'koi-pond', 'lucky-lever', 'neon-arcade', 'pirate-cove'] as const;
export type SlotId = (typeof SLOT_IDS)[number];
/**
 * Lever machines (one-armed bandits: 3–5 reels, a lever, a few lines) — slots on the same engine and routes
 * (`/slots/<id>`), shown in the lobby's own section «Machines» instead of «Slots». A new machine is one id here.
 */
export const LEVER_IDS = ['lucky-lever', 'neon-arcade', 'pirate-cove'] as const satisfies readonly SlotId[];
export type LeverId = (typeof LEVER_IDS)[number];
export const isLeverId = (g: string): g is LeverId => (LEVER_IDS as readonly string[]).includes(g);

/** All token amounts are whole tokens, integers. Payouts = floor(bet * multiplier). */
export const zAmount = z.number().int().positive().max(1_000_000_000);
/** Client-generated idempotency key, required on every bet-like request. */
export const zIdempotencyKey = z.string().min(8).max(64);
